import React from 'react';
import {format} from 'date-fns';
import DateFnsUtils from '@date-io/date-fns';
import {
    FormControlLabel,
    Switch,
    TextField,
    TextareaAutosize, InputAdornment,
} from "@material-ui/core";
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
    KeyboardDateTimePicker,
} from '@material-ui/pickers';
import {Autocomplete} from '@material-ui/lab';
import useStyles from '../../styles/styles';
import _ from 'lodash';
import PayoutStrategyInput from "./PayoutStrategyInput";
import TrafficSourceOfferInput from "./TrafficSourceOfferInput";

const RenderInput = ({item, disabled, readOnly = false, value, handleFilterChange = () => {}, handleSwitchChange = () => {}, handleInputChange = () => {}, setInputs, inputs, data, style, inputType, subKey}) => {
    const {label, key, type, val, required, dateFormat, returnKey, displayKey, options, sort, useVal } = item;
    const classes = useStyles();
    let hasKey = '';

    const findOptionName = (options, id) => {
        const option = options.find( item => item.id === id)
        return option ? option.name : null
    }

    const findKeyById = (options, option, key) => {
        if(!option) {
            return null
        }

        const id = option.id ? option.id : option
        const foundOption = options.find( item => item.id === id)
        return foundOption ? foundOption[key] : null
    }

    const handleKey = (e) => {
        if (e.key === 'Enter') {
            e.stopPropagation()
        }
    }

    switch (type) {
        case 'switch':
            return (
                <FormControlLabel
                    control={
                        <Switch
                            onChange={handleSwitchChange}
                            checked={value || false}
                            disabled={disabled || false}
                            name={key}
                            inputProps={{'aria-label': 'primary checkbox'}}
                        />
                    }
                    label={label || null}
                />
            );
        case 'payoutStrategyInput':
            return (
                <PayoutStrategyInput
                    item={item}
                    disabled={disabled}
                    value={value}
                    handleFilterChange={handleFilterChange}
                    handleSwitchChange={handleSwitchChange}
                    handleInputChange={handleInputChange}
                    setInputs={setInputs}
                    inputs={inputs}
                    data={data}
                />
            );
        case 'trafficSourceOfferInput':
            return (
                <TrafficSourceOfferInput
                    item={item}
                    value={value}
                    handleSwitchChange={handleSwitchChange}
                    handleInputChange={handleInputChange}
                    setInputs={setInputs}
                    inputs={inputs}
                    data={data}
                />
            );
        case 'autoCompleteSimple':
            return (
                <Autocomplete
                    size="medium"
                    className={classes.autoComplete}
                    value={value}
                    options={data[val].map(entry => entry.id)}
                    getOptionLabel={(option) => findOptionName(data[val], option)}
                    onChange={(event, value) => {
                        handleFilterChange(findOptionName(data[val], value), key);
                    }}
                    onKeyDown={e => handleKey(e)}
                    renderInput={(params) => <TextField {...params} label={label} fullWidth error={!value && required}/>}
                />
            );
        case 'autoCompleteByKey':
            return (
                <Autocomplete
                    size="medium"
                    disabled={disabled}
                    className={classes.autoComplete}
                    value={value}
                    options={options ? options : []}
                    getOptionLabel={(option) => {
                        const allOptions = options ? options : data[val]
                        return findKeyById(allOptions, option, displayKey)
                    }}
                    onChange={(event, value) => {
                        const allOptions = options ? options : data[val]
                        handleFilterChange(findKeyById(allOptions, value, returnKey));
                    }}
                    onKeyDown={e => handleKey(e)}
                    renderInput={(params) => <TextField {...params} label={label} fullWidth error={value === '' && required}/>}
                />
            );
        case 'autoComplete':
            hasKey = (val, checkKey) => _.has(val, checkKey);
            let newOptions = [];
            const hasEnums = _.has(data[val], 'enumValues');
            if (hasKey(item, 'options') && options.length) {
                newOptions = options; 
            } else if (hasEnums) {
                newOptions = data[val].enumValues;
            } else if (_.has(data[val], 'nodes')) {
                newOptions = data[val].nodes;
            } else if (val && useVal) {
                newOptions = data[val];
            } else {
                newOptions = data;
            }

            if (sort && hasEnums) {
                newOptions = _.orderBy(newOptions, ['name'], ['asc']);
            }

            return (
                <Autocomplete
                    size="medium"
                    disabled={disabled}
                    className={classes.autoComplete}
                    value={value || ''}
                    onChange={(event, value) => {
                        let newValue = value;
                        if (hasKey(value, returnKey)) {
                            newValue = value[returnKey];
                        }
                        handleFilterChange(newValue, key);
                    }}
                    options={newOptions}
                    getOptionLabel={option => {
                        if (hasKey(option, displayKey)) {
                            return option[displayKey];
                        }
                        return option;
                    }}
                    onKeyDown={e => handleKey(e)}
                    renderInput={params => <TextField {...params} label={label} fullWidth
                                                      error={!value && required}/>}
                />
            );
        case 'autoCompleteApi':
            hasKey = (val, checkKey) => _.has(val, checkKey);
            return (
                <Autocomplete
                    size="medium"
                    disabled={disabled}
                    className={classes.autoComplete}
                    value={value || ''}
                    onChange={(event, value) => {
                        let newValue = value;
                        if (hasKey(value, returnKey)) {
                            newValue = value[returnKey];
                        }
                        handleFilterChange(newValue, key);
                    }}
                    options={options ? options : data[val]}
                    getOptionLabel={option => {
                        if (hasKey(option, displayKey)) {
                            return option[displayKey];
                        }
                        return option;
                    }}
                    onKeyDown={e => handleKey(e)}
                    renderInput={params => <TextField {...params} label={label} fullWidth error={!value && required}/>}
                />
            );
        case 'autoCompleteNameWithId':
            hasKey = (val, checkKey) => _.has(val, checkKey);
            return (
                <Autocomplete
                    size="medium"
                    disabled={disabled}
                    className={classes.autoComplete}
                    value={value || ''}
                    onChange={(event, value) => {
                        let newValue = value;
                        if (hasKey(value, returnKey)) {
                            newValue = value[returnKey];
                        }
                        handleFilterChange(newValue, key);
                    }}
                    options={_.has(data[val], 'enumValues') ? data[val].enumValues : _.has(data[val], 'nodes') ? data[val].nodes : data}
                    getOptionLabel={option => {
                        if (hasKey(option, displayKey) && hasKey(option, returnKey)) {
                            return `${option[displayKey]} (${option[returnKey]})`;
                        }
                        return option;
                    }}
                    onKeyDown={e => handleKey(e)}
                    renderInput={params => <TextField {...params} label={label} fullWidth
                                                      error={!value && required}/>}
                />
            );
        case 'autoComplete-multiple':
            hasKey = (val, checkKey) => _.has(val, checkKey);
            return (
                <Autocomplete
                    multiple
                    size="medium"
                    disabled={disabled}
                    className={classes.autoComplete}
                    value={value}
                    filterSelectedOptions
                    onChange={(event, value) => {
                        let newValue = value;
                        if (hasKey(value, returnKey)) {
                            newValue = value[returnKey];
                        }
                        handleFilterChange(newValue);
                    }}
                    options={_.has(data[val], 'enumValues') ? data[val].enumValues : _.has(data[val], 'nodes') ? data[val].nodes : data}
                    getOptionLabel={option => {
                        if (hasKey(option, displayKey)) {
                            return option[displayKey];
                        }
                        return option;
                    }}
                    onKeyDown={e => handleKey(e)}
                    renderInput={params => <TextField {...params} label={label} fullWidth
                                                      error={!value && required}/>}
                />
            );
        case 'date':
            return (
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker
                        ampm={false}
                        variant="inline"
                        format={dateFormat || 'yyyy-MM-dd'}
                        margin="normal"
                        id={key}
                        disabled={disabled}
                        label={label}
                        value={value || null}
                        onChange={date => handleFilterChange(date ? dateFormat ? format(date, dateFormat) : date.toISOString() : null, key)}
                        KeyboardButtonProps={{
                            'aria-label': 'change date',
                        }}
                        className={`${classes.formControl} ${(value === null || value === '') && required ? 'Mui-error' : ''}`}
                    />
                </MuiPickersUtilsProvider>
            );
        case 'dateTime':
            return (
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDateTimePicker
                        ampm={false}
                        variant="inline"
                        id={key}
                        style={style}
                        label={label}
                        value={value || null}
                        onChange={date => handleFilterChange(date ? date.toISOString() : null, key)}
                        KeyboardButtonProps={{
                            'aria-label': 'change date',
                        }}
                        className={`${classes.formControl} ${(value === null || value === '') && required ? 'Mui-error' : ''}`}
                    />
                </MuiPickersUtilsProvider>
            );
        case 'dateTimeLocal':
            return (
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDateTimePicker
                        ampm={false}
                        variant="inline"
                        id={key}
                        style={style}
                        label={label}
                        value={value || null}
                        onChange={date => handleFilterChange(date)}
                        KeyboardButtonProps={{
                            'aria-label': 'change date',
                        }}
                        className={`${classes.formControl} ${(value === null || value === '') && required ? 'Mui-error' : ''}`}
                    />
                </MuiPickersUtilsProvider>
            );
        case 'time':
            return (
                <TextField
                    id={key}
                    name={key}
                    label={label}
                    type="time"
                    value={value || ''}
                    className={classes.textField}
                    onChange={handleInputChange}
                    error={value === '' && required}
                    onKeyDown={e => handleKey(e)}
                />
            );
        case 'textArea':
            return (
                <TextareaAutosize
                    style={{width: '100%', height: '320px', overflow: 'scroll'}}
                    defaultValue={value}
                    name={key}
                    value={value || ''}
                    onChange={handleInputChange}
                    disabled={disabled}
                />
            );
        case 'percentage':
            return (
                <TextField
                    id={key}
                    name={key}
                    label={label}
                    value={value > 0 ? value : ''}
                    type={'number'}
                    onChange={(event) => handleInputChange(event, subKey)}
                    error={value === '' && required}
                    fullWidth
                    disabled={disabled}
                    readOnly={readOnly}
                    onKeyDown={e => handleKey(e)}
                    InputProps={{
                        endAdornment: <InputAdornment position="end">%</InputAdornment>
                    }}
                />
            );
        default:
            let defaultValue = inputType === 'number' && value >= 0 ? value : '';
            if (defaultValue === null) {
                defaultValue = '';
            }
            return (
                <TextField
                    id={key}
                    name={key}
                    label={label}
                    value={inputType === 'number' ? defaultValue : value || ''}
                    type={type}
                    onChange={(event) => handleInputChange(event, subKey)}
                    error={value === '' && required}
                    fullWidth
                    disabled={disabled}
                    readOnly={readOnly}
                    onKeyDown={e => handleKey(e)}
                />
            );
    }
};

export default RenderInput;
